
import { Component, inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as XLSX from 'xlsx';
import { renderAsync } from 'docx-preview';
import Handsontable from 'handsontable';

@Component({
  selector: 'universal-viewer',
  templateUrl: './universal-viewer.component.html',
  styleUrls: ["./universal-viewer.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: []
})

export class UniversalViewerComponent implements OnInit {
  @Input() blob
  private sanitizer = inject(DomSanitizer)
  viewerType: 'iframe' | 'excel' | 'word' = 'iframe';
  fileURL: any;
  excelData: any[] = [];
  excelHtml



  ngOnInit() {
    if (this.blob) {
      this.loadFile(this.blob);
    }
  }

  private readonly RENDERERS = [
    { match: (t: string) => t.includes('excel') || t.includes('sheet'), fn: 'renderExcel' },
    { match: (t: string) => t.includes('word') || t.includes('document'), fn: 'renderWord' },
  ] as const;

  private readonly IFRAME_TYPES = ['pdf', 'image', 'text', 'octet-stream'];

  loadFile(blob: Blob) {
    const type = blob.type;

    for (const r of this.RENDERERS) {
      if (r.match(type)) {
        this[r.fn](blob);
        return;
      }
    }

    if (this.IFRAME_TYPES.some(t => type.includes(t))) {
      const url = URL.createObjectURL(blob);
      this.fileURL = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    } else {
      this.fileURL = null;
    }
    this.viewerType = 'iframe';
  }

  async renderExcel(blob: Blob) {

    const buffer = await blob.arrayBuffer();

    const workbook = XLSX.read(buffer, { type: 'array' });

    const sheet = workbook.Sheets[workbook.SheetNames[0]];

    const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });

    this.viewerType = 'excel';

    setTimeout(() => {

      const container = document.getElementById('excel-container');

      new Handsontable(container!, {
        data,
        rowHeaders: true,
        colHeaders: true,
        stretchH: 'all',
        height: 600,
        licenseKey: 'non-commercial-and-evaluation'
      });

    });
  }

  async renderWord(blob: Blob) {

    this.viewerType = 'word';

    setTimeout(() => {
      const container = document.getElementById('word-container');
      renderAsync(blob, container);
    });
  }
}
